import axios from '../axios';
import { NotificationManager } from 'react-notifications';
import history from '../history';
import { element } from 'prop-types';
import moment from 'moment';
import { jwtDecode } from "jwt-decode";

export const clearLoginError = () => ({
  type: 'CLEAR_LOGIN_ERROR',
});
 
export const userLogin = (data, email) => async (dispatch) => {
  await axios
    .post('/userLogin', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if(response.data.role == "doctor" ){
      console.log(response)
      // debugger
      localStorage['accessToken'] = response.data.accessToken;
      localStorage['doctorId'] = email;
      localStorage['user'] = response.data.role;
      localStorage['labelling'] = response.data.appConfiguration.labelling;
      localStorage["adminId"] = response.data.appConfiguration.userId;
      localStorage["validation"] = response.data.appConfiguration.validation;
      localStorage["patientPayment"] = response.data.appConfiguration.patient_payment;
      localStorage['name'] = response.data.firstname;
      localStorage['role'] = response.data.role[0];
      localStorage['lhi']= response.data.appConfiguration.hasOwnProperty('lhi')? response.data.appConfiguration.lhi.toString(): 'true'
      console.log(localStorage.lhi)

      localStorage["export_data"] = response.data.appConfiguration?.export_data;
      localStorage["plan"] = response.data.plan.find(element => element == "covid");
      localStorage["Tb"] = response.data.plan.find(element => element == "tb");
 
      localStorage["copd"] = response.data.plan.find(element => element == "copd");
      localStorage["asthma"] = response.data.plan.find(element => element == "asthma");
 
      localStorage["spirometry"] = response.data.plan.find(element => element == "spirometry");
      localStorage["assessments_tab"] = response.data.appConfiguration.assessments_tab;
      localStorage['rpm'] = response.data.plan.find(element => element === "rpm");
      localStorage['accessType'] = response.data.accessType
      // localStorage["fev1fvc_2_value"] = response.plan.find(element => element === "spirometry");
      // localStorage["fvc_3_value"] = response.plan.find(element => element === "spirometry");
      // localStorage["fev1_3_value"] = response.plan.find(element => element === "spirometry");
     
      localStorage["sharedPatient"] = response.data.appConfiguration.shared_patient;
      localStorage["bulkupload"] = response.data.appConfiguration.bulkupload;
      localStorage["longitudinal_study"] = response.data.appConfiguration.longitudinal_study;
      localStorage["ageValid"]= response.data.appConfiguration.age_valid;
      localStorage["timezone"] = response.data.timezone;
      localStorage["filters"] = response.data.appConfiguration.filters;
      localStorage["search"] = response.data.appConfiguration.search;



      try{
        const token = response.data.accessToken;
        const decoded = jwtDecode(token);
        console.log(decoded);
        const userGroup = decoded.user_group;
        
        // Check if any string contains the word 'clinics'
        const containsClinics = userGroup.some((element) => element.includes("clinics"));
        localStorage["clinics"] = containsClinics;
        
        console.log(containsClinics);
      }catch(e){
console.log("jwt decoding error");
localStorage["clinics"] = false;
      }
    
 
      if(localStorage.validation !== "true" || localStorage.longitudinal_study === "true"){
        history.push('/home');
      }else if (localStorage.validation === "true"&&localStorage.longitudinal_study !== "true") {
        history.push("/validationHome");
      }else{
        history.push('/home');
      }
   
      // history.push('/superadmin');
      // history.push('/adminsettings');
      } else if(response.data.role == "superadmin"){
        // NotificationManager.success("Login Success", "Success", 2000);
        localStorage['accessToken'] = response.data.accessToken;
        localStorage['user'] = response.data.role;
        localStorage['doctorId'] = email;
        localStorage["plan"] = null;
        localStorage["Tb"] = null;
        localStorage['name'] = response.data.firstname;
        localStorage['role'] = response.data.role[0];
        localStorage["assessments_tab"] = response.data.appConfiguration.assessments_tab;
 
        localStorage["copd"] = null;
        localStorage["asthma"] = null;
  
        try{
          const token = response.data.accessToken;
          const decoded = jwtDecode(token);
          console.log(decoded);
          const userGroup = decoded.user_group;
          
          // Check if any string contains the word 'clinics'
          const containsClinics = userGroup.some((element) => element.includes("clinics"));
          localStorage["clinics"] = containsClinics;
          
          console.log(containsClinics);
        }catch(e){
  console.log("jwt decoding error");
  localStorage["clinics"] = false;
        }
 
        localStorage["spirometry"] = null;
        // localStorage["fev1fvc_2_value"] = null;
        // localStorage["fvc_3_value"] = null;
        // localStorage["fev1_3_value"] = null;
        localStorage['ageValid']= response.data.appConfiguration.age_valid;
        localStorage["sharedPatient"] = response.data.appConfiguration.shared_patient;
        localStorage['lhi']= response.data.appConfiguration.hasOwnProperty('lhi')? response.data.appConfiguration.lhi.toString(): 'true'
        localStorage["bulkupload"] = response.data.appConfiguration.bulkupload;
        localStorage["export_data"] = response.data.appConfiguration?.export_data;
        localStorage["patientPayment"] = response.data.appConfiguration.patient_payment;
        localStorage["timezone"] = response.data.timezone;
        localStorage["filters"] = response.data.appConfiguration.filters;
        localStorage["search"] = response.data.appConfiguration.search;
        localStorage['accessType'] = response.data.accessType
        // history.push('/admindashboard');
        history.push('/superadmin');
      }else {
        // if(localStorage.validation !== "true" || localStorage.longitudinal_study === "true"){
        //   history.push('/analytics');
        // }else if(localStorage.validation === "true"){
        //   history.push('/patients');
        // }else{
        //   history.push('/analytics');
        // }
        // NotificationManager.success("Login Success", "Success", 2000);
        localStorage['accessToken'] = response.data.accessToken;
        localStorage['user'] = response.data.role;
        localStorage['doctorId'] = email;
        
        localStorage["assessments_tab"] = response.data.appConfiguration.assessments_tab;

        localStorage["plan"] = response.data.plan.find(
          (element) => element == "covid"
        );
        
        localStorage["Tb"] = response.data.plan.find(
          (element) => element == "tb"
        );
        localStorage["copd"] = response.data.plan.find(
          (element) => element == "copd"
        );
        localStorage["asthma"] = response.data.plan.find(
          (element) => element == "asthma"
        );

        localStorage["spirometry"] = response.data.plan.find(
          (element) => element == "spirometry"
        );
        
      try{
        const token = response.data.accessToken;
        const decoded = jwtDecode(token);
        console.log(decoded);
        const userGroup = decoded.user_group;
        
        // Check if any string contains the word 'clinics'
        const containsClinics = userGroup.some((element) => element.includes("clinics"));
        localStorage["clinics"] = containsClinics;
        
        console.log(containsClinics);
      }catch(e){
console.log("jwt decoding error");
localStorage["clinics"] = false;
      }
        localStorage['name'] = response.data.firstname;
        localStorage['role'] = response.data.role[0];
        localStorage['accessType'] = response.data.accessType
        localStorage['ageValid']= response.data.appConfiguration.age_valid;
        // localStorage["fev1fvc_2_value"] = null;
        // localStorage["fvc_3_value"] = null;
        // localStorage["fev1_3_value"] = null;
       
        localStorage["sharedPatient"] = response.data.appConfiguration.shared_patient;
         localStorage['lhi']= response.data.appConfiguration.hasOwnProperty('lhi')? response.data.appConfiguration.lhi.toString(): 'true'
        localStorage['labelling'] = response.data.appConfiguration.labelling;
        localStorage["bulkupload"] = response.data.appConfiguration.bulkupload;
        localStorage["export_data"] = response.data.appConfiguration?.export_data;
        localStorage["timezone"] = response.data.timezone;
        localStorage["filters"] = response.data.appConfiguration.filters;
        localStorage["search"] = response.data.appConfiguration.search;
        localStorage["patientPayment"] = response.data.appConfiguration.patient_payment;
        history.push('/admindashboard');
        // history.push('/superadmin');
      }
     
    })
    .catch((error) => {
      let errorMessage = 'Please try logging in after some time.';
  
      if (error.response) {
        if (error.response.data.message) {
          if (error.response.data.message === 'Login limit exceeded') {
            errorMessage = 'Too many login attempts. Please try logging in after some time.';
          } else if (error.response.data.message === 'No user details found with the given details, please sign up.') {
            errorMessage = 'No user found. Please verify the username.';
          } else {
            errorMessage = error.response.data.message;
          }
        } else if (error.response.status === 500) {
          errorMessage = 'Please try logging in after some time.';
        }
      } else if (error.request) {
        errorMessage = 'No response from server. Please check your network connection.';
      }
    
      dispatch({ type: 'USER_LOGIN_FAILURE', payload: errorMessage });
    })
}


 
export const adminLogin = (data, email) => async (dispatch) => {
  await axios
    .post('/userLogin', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      localStorage['accessToken'] = response.data.accessToken;
      localStorage['user'] = response.data.role;
      localStorage['doctorId'] = email;
      localStorage["sharedPatient"] = response.data.appConfiguration.shared_patient;
      localStorage["bulkupload"] = response.data.appConfiguration.bulkupload;
      localStorage["filters"] = response.data.appConfiguration.filters;
      localStorage["search"] = response.data.appConfiguration.search;
      localStorage["assessments_tab"] = response.data.appConfiguration.assessments_tab;
      localStorage['accessType'] = response.data.accessType

      try{
        const token = response.data.accessToken;
        const decoded = jwtDecode(token);
        console.log(decoded);
        const userGroup = decoded.user_group;
        
        // Check if any string contains the word 'clinics'
        const containsClinics = userGroup.some((element) => element.includes("clinics"));
        localStorage["clinics"] = containsClinics;
        
        console.log(containsClinics);
      }catch(e){
console.log("jwt decoding error");
localStorage["clinics"] = false;
      }
      history.push('/admindashboard');
    })
    .catch((error) => {
      // console.log(error.response);
      let errorMessageShown = false;
      if (error.response) {
        if (error.response.data) {
          if (error.response.data.message === 'email_not_verified') {
            NotificationManager.error('Email is not verified', 'Error', 3000);
            errorMessageShown = true;
          }
        }
      }
      if (!errorMessageShown) {
        NotificationManager.error(error.response.data.message, 'Error', 3000);
      }
    });
};
 
// export const userSignup = (data) => async (dispatch) => {
//   await axios
//     .post('/userSignup', data, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     })
//     .then((response) => {
//       // console.log(response);
//     })
//     .catch((error) => {
//       // console.log(error.response);
//       NotificationManager.error(
//         'Unable to register, Please try again',
//         'Error',
//         3000
//       );
//     });
// };
 
export const fetchZipCodes = () => async (dispatch) => {
  await axios
    .get('/getzipcodes', {
      headers: { accessToken: localStorage.accessToken },
    })
    .then((response) => {
      if (!localStorage.zip) {
        localStorage['zip'] = response.data.zipcodes_list[0];
      }
 
      dispatch({
        type: 'IS_FETCHING_ZIP',
      });
 
      dispatch({
        type: 'ZIP_LIST',
        payload: response.data.zipcodes_list,
      });
 
 
    })
    .catch((error) => {
      console.log(error);
 
      dispatch({
        type: 'IS_FETCHING_ZIP',
      });
    });
};
 
export const fetchAnalytics = (enddate, startdate) => async (dispatch) => {
 
  let data = new FormData();
  // console.log(enddate)
  // console.log(startdate)
 
  data.append('doctorId', localStorage.doctorId);
  const startDate1 = moment(startdate).format("YYYY-MM-DD");
  const endDate1 = moment(enddate).format("YYYY-MM-DD");
  // getAnalyticsForAdmin?created_on_start=${startDate1}00:00:00&created_on_end=${endDate1}23:59:59
  await axios
    .get(`/getAnalyticsForDoctor?created_on_start=${startDate1} 00:00:00&created_on_end=${endDate1} 23:59:59`, {
      headers: { accessToken: localStorage.accessToken },
    })
    .then((response) => {
      // console.log(response.data.weeknumber)
      if(response.data.weeknumber != {}){
        dispatch({
          type: 'IS_FETCHING_ANALYTICS',
        });
 
        dispatch({
          type: 'ANALYTICS',
          payload: response.data,
        });
      }else{
        dispatch({
          type: 'EMPTY_PATIENTS',
        });
 
      }
   
    })
    .catch((error) => {
      console.log(error);
 
      dispatch({
        type: 'IS_FETCHING_ANALYTICS',
      });
    });
};
 
export const fetchAnalyticsforadmin = () => async (dispatch) => {
 
  let data = new FormData();
  // console.log(enddate)
  // console.log(startdate)
 
  const today = moment();
  const startDate = today.clone().subtract(6, 'days').format("YYYY-MM-DD");
  const endDate = today.format("YYYY-MM-DD");
 
  data.append('doctorId', localStorage.doctorId);
 
  // let date = new Date()
  // console.log(date)
  // let enddate = moment(date).format("YYYY-MM-DD")
  // console.log(enddate)
  // let enddateparams = enddate.split("-")
  // enddateparams[enddateparams.length-1] = "01"
 
  // enddateparams[enddateparams.length-1] - 7
 
  // console.log(enddateparams)
  // let startdate = enddateparams.join("-")
  // let startdate = "2021-03-01"
  // console.log(startdate)
  // const startDate1 = moment(startdate).format("YYYY-MM-DD");
  // const endDate1 = moment(enddate).format("YYYY-MM-DD");
  // /records/${localStorage.doctorId}/${startdate} 00:00:00/${enddate} 23:59:59
  await axios
  .get(`/getAnalyticsForAdmin?created_on_start=${startDate} 00:00:00&created_on_end=${endDate} 23:59:59`, {
      headers: { accessToken: localStorage.accessToken },
    })
    .then((response) => {
      dispatch({
        type: 'IS_FETCHING_ANALYTICS',
      });
 
      dispatch({
        type: 'ANALYTICS',
        payload: response.data,
      });
    })
    .catch((error) => {
      console.log(error);
 
      dispatch({
        type: 'IS_FETCHING_ANALYTICS',
      });
    });
};
 
export const fetchAssessmentRecords = (enddate, startdate) => async (dispatch) => {
 
  let data = new FormData();
  // console.log(enddate)
  // console.log(startdate)
 
  data.append('doctorId', localStorage.doctorId);
 
  // let date = new Date()
  // console.log(date)
  // let enddate = moment(date).format("YYYY-MM-DD")
  // console.log(enddate)
  // let enddateparams = enddate.split("-")
  // enddateparams[enddateparams.length-1] = "01"
 
  // enddateparams[enddateparams.length-1] - 7
 
  // console.log(enddateparams)
  // let startdate = enddateparams.join("-")
  // let startdate = "2021-01-01"
  // console.log(startdate)
 
 
  await axios
    .get(`/records/${localStorage.doctorId}/${startdate} 00:00:00/${enddate} 23:59:59`, {
      headers: { accessToken: localStorage.accessToken },
    })
    .then((response) => {
      // console.log(response);
      dispatch({
        type: 'ASSESSMENTRECORD',
        payload: response.data,
      });
    })
};
 
export const fetchDoctors = () => async (dispatch) => {
  await axios
  .get(`/getDoctors`, {
    headers: { accessToken: localStorage.accessToken },
  })
  .then((response) => {
    // console.log(response);
    dispatch({
      type: 'DOCTORS',
      payload: response.data.data,
    });
  })
 
};
 
// export const fetchPatients = (endDate, startDate) => async (dispatch) => {
//   if (startDate !== "" && endDate !== "") {
//     await axios
//       .get(`/getPatientsAssessments/${startDate} 00:00:00/${endDate} 23:59:59`, {
//         headers: { accessToken: localStorage.accessToken },
//       })
//       .then((response) => {
//         console.log(response);
       
//         dispatch({
//           type: "PATIENTS",
//           payload: response.data.data,
//         });
     
//       });
//   }
//   else {
//     await axios
//       .get(`/getPatientsAssessments`, {
//         headers: { accessToken: localStorage.accessToken },
//       })
//       .then((response) => {
//       console.log(response);
//         dispatch({
//           type: "PATIENTS",
//           payload: response.data,
//         });
//       });
//   }
 
// };
 
 
export const fetchPatients = (endDate, startDate) => async (dispatch) => {
  if (startDate !== "" && endDate !== "") {
    await axios
      .get(`/getPatientsAssessments?created_on_start=${startDate} 00:00:00&created_on_end=${endDate} 23:59:59`, {
        headers: { accessToken: localStorage.accessToken,
        },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("message")) {
          // console.log("Data not Found");
          dispatch({
            type: "EMPTY_PATIENTS",
            payload: []
          });
        } else {
          // console.log("Data Found");
          dispatch({
            type: "PATIENTS",
            payload: response.data.data,
          });
        }
      });
  } else {
    await axios
      .get(`/getPatientsAssessments`, {
        headers: { accessToken: localStorage.accessToken,
        },
      })
      .then((response) => {
        // console.log(response);
       
        if (response.data.hasOwnProperty("message")) {
          dispatch({
            type: "EMPTY_PATIENTS",
          });
        } else {
          dispatch({
            type: "PATIENTS",
            payload: response.data.data,
          });
        }
      });
  }
};
 
 
 
export const userLogout = () => (dispatch) => {
  dispatch({
    type: 'USER_LOGOUT',
  });
};
 
 